import { render } from "./Footer.vue?vue&type=template&id=ff495486&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=ff495486&scoped=true&lang=css"

import exportComponent from "/home/vrushaket@rhythm.local/vrushaket/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff495486"]])

export default __exports__